import { defineComponent } from "vue";
import { mapState } from "pinia";

import { LookupService } from "../../../services/lookup-service";
import { Container } from "aurelia-dependency-injection";
import { AnalyticsCategory, AnalyticsService } from "../../../services/analytics.service";
import banner4 from "../../../../img/axxess-intelligence44.png";
import banner5 from "../../../../img/axxess-connect55.png";
import banner6 from "../../../../img/axxess-central60.png";
import { useConversationStore } from "../store/useConversationStore";

import PatientList from "../../Common/PatientList/PatientList.vue";
import EmployeeList from "../../Common/EmployeeList/EmployeeList.vue";
import LevelTwo from "../../LevelTwo/LevelTwo.vue";
import TabsAnimatedHeader from "../../../resources-vue/vue-custom-elements/TabsAnimatedHeader/TabsAnimatedHeader.vue";
import DashboardHeader from "../../../resources-vue/vue-elements/DashboardHeader/DashboardHeader.vue";
import ChatTutorial from "../components/ChatTutorial/ChatTutorial.vue";

export default defineComponent({
    components: {
        PatientList,
        EmployeeList,
        DashboardHeader,
        LevelTwo,
        TabsAnimatedHeader,
        ChatTutorial
    },

    data() {
        return {
            router: null,
            _lookupService: null,
            _analyticsServices: null as AnalyticsService,
            showBorder: true as boolean,
            showPatients: false as boolean,
            showEmployees: false as boolean,
            barColour: "border-bottom: 5px solid #ba1111",
            activeItem: null,
            banners: [
                { src: banner4, link: "https://www.axxess.com/help/agencycore/axxess-intelligence/ask-axxess/" },
                { src: banner5, link: "https://www.axxess.com/help/axxess-central/axxess-connect/" },
                { src: banner6, link: "https://www.axxess.com/help/axxess-central/" }
            ],
            banner: { src: "", link: "" },
            showBanner: true,
            intervalId: null as any
        };
    },

    created() {
        this._lookupService = Container.instance.get(LookupService);
        this._analyticsServices = Container.instance.get(AnalyticsService);
        const randomIndex = Math.floor(Math.random() * this.banners.length);
        this.banner = this.banners[randomIndex];
        this.$watch(
            () => this.$route.params,
            () => {
                this.activeItem = this.$route.meta.menuName;
            }
        );
    },

    mounted() {
        this.intervalId = setInterval(() => {
            const randomIndex = Math.floor(Math.random() * this.banners.length);
            this.banner = this.banners[randomIndex];
        }, 20000);
    },

    computed: {
        ...mapState(useConversationStore, ["showChatTutorial"])
    },

    methods: {
        goTo(path: string) {
            this.$router.push(path);
        },

        isActivePath(path: string) {
            return this.$route.matched?.some((route) => route.path == path);
        },
        closeBanner(banner: any) {
            let action = "";
            switch (banner.link) {
                case this.banners[0].link:
                    action = "Home page Banner (X/Close) - Axxess intelligence";
                    break;

                case this.banners[1].link:
                    action = "Home page Banner (X/Close) - Axxess Connect";
                    break;

                case this.banners[2].link:
                    action = "Home page Banner (X/Close) - Axxess Central";
                    break;

                default:
                    action = "Home page Banner (X/Close)";
            }
            this._analyticsServices.logEvent({
                category: AnalyticsCategory.Banners,
                action: action
            });
            this.showBanner = false;
            clearInterval(this.intervalId);
        },
        addLog(banner: any) {
            let action = "";
            switch (banner.Link) {
                case this.banners[0].link:
                    action = "Home page Banner  (click/redirect) - Axxess intelligence";
                    break;

                case this.banners[1].link:
                    action = "Home page Banner  (click/redirect) - Axxess Connect";
                    break;

                case this.banners[2].link:
                    action = "Home page Banner  (click/redirect) - Axxess Central";
                    break;

                default:
                    action = "Home page Banner (click/redirect)";
            }
            this._analyticsServices.logEvent({
                category: AnalyticsCategory.Banners,
                action: action
            });
        }
    }
});
